import Icon    from "_components/atoms/icon/index.js";
import Image   from "_components/atoms/image";
import ToolTip from "_components/atoms/tooltip";

import useStyles from "./styles.js";

const component = props => {
	const {
		darkMode,
		emotesList,
		handleLikeAction,
		hoverState,
		showReactionsSlider,
		hideReactionsSlider
	} = props;

	const { classes } = useStyles ( { hoverState } );

	return (
		<div
			className    = { classes.root }
			onMouseEnter = { showReactionsSlider }
			onMouseLeave = { hideReactionsSlider }
		>
			<span className = { classes.test }>
				{<LikeIcon darkMode = { darkMode } />}
			</span>

			<div className = { classes.emoteContainer }>
				<Emotes
					emotesList       = { emotesList }
					handleLikeAction = { handleLikeAction }
				/>
			</div>
		</div>
	);

};

export default component;

const LikeIcon = ( { darkMode } ) => {
	const { classes } = useStyles ();

	if ( darkMode ) {
		return (
			<Image
				className = { classes.svgIconsDark }
				src       = "/icons/heart_icon_dark.webp"
			/>
		);
	}

	return (
		<Icon className = { classes.svgIcons }
			name           = "broadcastLike"
		>
		</Icon>
	);
};

const Emotes = ( { emotesList, handleLikeAction } ) => {
	const { classes } = useStyles ();

	return Object.keys ( emotesList ).map ( d => {

		return (
			<ToolTip
				key        = { emotesList[d].reactionId }
				arrow
				enterDelay = { 0 }
				leaveDelay = { 0 }
				placement  = "bottom-end"
				title      = { d }
			>
				<span
					className = { classes.emoteRoot }
					onClick   = { () => handleLikeAction ( { name: d, ...emotesList[d] } ) }
				>
					<div className = { classes.imgWrapper }>
						<Image
							useOriginal
							alt       = ""
							className = { classes.emotes }
							src       = { emotesList[d].url }
						/>
					</div>
				</span>
			</ToolTip>
		);
	} );
};
